import { HttpClient } from '../../httpClient.js'

export async function post(
  httpClient: HttpClient,
  eventId: number,
): Promise<void> {
  return httpClient
    .url(`/events/${eventId}/keep-alive`)
    .post({ event_id: eventId })
    .json()
}
